import React, { useEffect } from "react";

const InputBox = ({ apiKey, setApiKey, hasApiKey, setHasApiKey }) => {
  useEffect(() => {
    const storedApiKey = localStorage.getItem("apiKey");

    if (storedApiKey) {
      setApiKey(storedApiKey);
      setHasApiKey(true);
    }
  }, []);

  useEffect(() => {
    if (!hasApiKey && hasApiKey !== null) {
      setApiKey(null);
      localStorage.removeItem("apiKey");
    } else if (hasApiKey) {
      localStorage.setItem("apiKey", apiKey);
    }
  }, [hasApiKey]);

  return (
    <div className="flex flex-row items-center justify-center">
      <input
        className="appearance-none border rounded rounded-r-none w-2/3 lg:w-1/2 py-1 px-1.5 md:py-2 md:px-3 text-gray-700 text-xs md:text-base leading-tight focus:outline-none focus:shadow-outline"
        id="api_key"
        type="password"
        placeholder="API Key"
        value={apiKey || ""}
        onChange={(e) => {
          setApiKey(e.target.value);
        }}
        disabled={hasApiKey}
      />
      <button
        className="bg-red-wood-light hover:bg-red-wood text-white md:text-base text-xs font-bold py-1 px-2 md:py-2 border-[1px] focus:outline-red-wood border-red-wood md:px-6 rounded-md rounded-l-none"
        onClick={() => setHasApiKey(!hasApiKey)}
      >
        {hasApiKey ? "Logout" : "Login"}
      </button>
    </div>
  );
};

export default InputBox;
